<template>
    <div>
        <div class="header-container fs-topbar">
            <div class="header">
                <vs-topbar vs-color="primary" class="fs-topbar" style="min-height:50px;">
                    <vs-avatar v-show='!switch1' vs-color="warning" icon="menu" @click="menu()"/>
                    <!-- <vs-button v-show='!switch1' vs-color-text="rgb(255, 255, 255)" vs-color="rgba(255, 255, 255, 0.3)" vs-type="flat" vs-radius="50%" vs-icon="menu" @click="menu()"></vs-button> -->
                    <h4><span v-show="switch1">&nbsp;&nbsp;</span> <i class="fab fa-blogger"></i> Blog Fortkol | Área
                        Administrativa</h4>
                    <!-- <vs-button vs-color-text="rgb(255, 255, 255)" vs-color="rgba(255, 255, 255, 0.3)" vs-type="flat" to="/vuesaxexample">Dashboard</vs-button>
                    <vs-button vs-color-text="rgb(255, 255, 255)" vs-color="rgba(255, 255, 255, 0.3)" vs-type="flat" to="/">Sobre</vs-button> -->
                    <!-- <vs-button vs-color-text="rgb(255, 255, 255)" vs-color="rgba(255, 255, 255, 0.3)" vs-type="flat" vs-radius="50%" vs-icon="more_vert" style="margin-left: auto;"></vs-button> -->

                    <!--<vs-dropdown vs-color="#c80948" style="margin-left: auto;">-->
                        <!--<vs-avatar vs-color="warning" icon="add_alert" :vs-badge="badgeAlert" vs-badge-color="primary"/>-->
                        <!--<vs-dropdown-menu style="font-family: ubuntu; width: 185px; font-size: 0.8em">-->
                            <!--<vs-dropdown-item>-->
                                <!--<i class="far fa-address-card"></i> Ver Minhas Notificações-->
                            <!--</vs-dropdown-item>-->
                            <!--<vs-dropdown-item vs-divider>-->
                                <!--<i class="far fa-comments"></i> Mandar uma notificação-->
                            <!--</vs-dropdown-item>-->
                        <!--</vs-dropdown-menu>-->
                    <!--</vs-dropdown>-->
                    <!--<vs-dropdown vs-color="#c80948" style="margin-left: auto;">-->
                        <!--<vs-avatar vs-color="warning" icon="settings"/>-->
                        <!--<vs-dropdown-menu style="font-family: ubuntu; width: 180px; font-size: 0.8em">-->
                            <!--<vs-dropdown-item>-->
                                <!--<i class="fas fa-cogs"></i> Parâmetros do Sistema-->
                            <!--</vs-dropdown-item>-->
                        <!--</vs-dropdown-menu>-->
                    <!--</vs-dropdown>-->
                    <!--<vs-dropdown vs-color="#c80948">-->
                        <!--<vs-avatar vs-color="warning" vs-type="gradient"/>-->
                        <!--<vs-dropdown-menu style="font-family: ubuntu; width: 120px; font-size: 0.8em">-->
                            <!--<vs-dropdown-item>-->
                                <!--<i class="far fa-address-card"></i> Meus Dados-->
                            <!--</vs-dropdown-item>-->
                            <!--<vs-dropdown-item vs-divider @click="cardModalLogin()">-->
                                <!--<i class="fas fa-lock-open"></i> Login-->
                            <!--</vs-dropdown-item>-->
                            <!--<vs-dropdown-item vs-divider>-->
                                <!--<i class="fas fa-lock-open"></i> Logout (sair)-->
                            <!--</vs-dropdown-item>-->
                        <!--</vs-dropdown-menu>-->
                    <!--</vs-dropdown>-->
                    <vs-switch v-model="switch1" vs-color="#DE5433" style="margin-left: auto; margin-right: 10px;">
                        <span slot="on">On</span>
                        <span slot="off">Off</span>
                    </vs-switch>
                </vs-topbar>
            </div>
        </div>
        <fs-sidebar :activeMenu='active' @ocultarMenu="ocultarMenu" :staticMenu='switch1'
                    @monitorarSwitch="monitorarSwitch"/>
    </div>
</template>

<script>
import { mapState } from 'vuex'
// Terceiros
import fontawesome from '@fortawesome/fontawesome'
import freeSolid from '@fortawesome/fontawesome-free-solid'
import brands from '@fortawesome/fontawesome-free-brands'
import regular from '@fortawesome/fontawesome-free-regular'
// import { faHeart } from '@fortawesome/fontawesome-free-regular' // Pega só o coração

// Componentes Próprios
import ModalFormLogin from '@/components/ModalFormLogin.vue'

// Configurações do FontAwesome
fontawesome.library.add(freeSolid)
fontawesome.library.add(brands)
fontawesome.library.add(regular)
// fontawesome.library.add(faHeart)

export default {
  data: () => ({
    active: false,
    badgeAlert: 10,
    switch1: true
  }),
  computed: {
    ...mapState('login', [
      'logged',
      'usuario'
    ]),
    activeMenu: function () {
      return this.activeMenu
    }
  },
  methods: {
    cardModalLogin () {
      this.$modal.open({
        parent: this,
        component: ModalFormLogin,
        hasModalCard: true
      })
    },
    monitorarSwitch (val) {
      console.log('passou')
      this.$emit('monitorarSwitch', val)
    },
    ocultarMenu () {
      this.active = false
    },
    menu () {
      if (this.active === false) {
        this.active = true
      } else {
        this.active = false
      }
    }
  },
  mounted () {
    this.$vs.notify({
      title: 'Seja bem vindo',
      text: 'É um prazer ter você de volta conosco!',
      color: 'danger',
      icon: 'favorite',
      position: 'top-center'
    })
  }
}
</script>

<style lang="scss">
    .fs-topbar {
        // z-index: 20000;
        z-index: 100;
    }

    .header-container {
        width: 100%;
        position: fixed;
        top: 0px;
    }

    .header {
        height: 35px;
        // width:960px;
        margin: 0px auto;
    }
</style>
